/**
 * Seasonal board decor — paper-cut cutouts layered behind the board content.
 * Admin sets the active season (config /config/public -> home_season).
 * Currently implemented: "halloween". Add new seasons as `case` blocks.
 */
export const SeasonalDecor = ({ season }) => {
  if (season !== "halloween") return null;
  return (
    <div className="pointer-events-none absolute inset-0 z-0" aria-hidden="true" data-testid="seasonal-decor">
      <style>{`
        @keyframes limaSway { 0%,100%{transform:rotate(-4deg);} 50%{transform:rotate(4deg);} }
        .lima-spider{transform-origin:top center;animation:limaSway 5s ease-in-out infinite;}
        .lima-spider2{animation-duration:6.5s;}
        .lima-paper{filter:drop-shadow(0 3px 3px rgba(0,0,0,0.35));}
      `}</style>

      <div className="absolute" style={{ top: 0, left: "26%" }}>
        <svg className="lima-spider" width="46" height="130" viewBox="0 0 46 130">
          <line x1="23" y1="0" x2="23" y2="66" stroke="#2c2926" strokeWidth="1.2" />
          <g className="lima-paper" transform="translate(23,86)" fill="#26231f" stroke="#26231f" strokeWidth="2.4" strokeLinecap="round">
            <path d="M0 0 C -14 -8 -20 -2 -26 -12" fill="none" /><path d="M0 0 C -13 0 -19 6 -25 4" fill="none" />
            <path d="M0 0 C -12 6 -16 12 -22 16" fill="none" /><path d="M0 0 C -8 10 -8 16 -12 22" fill="none" />
            <path d="M0 0 C 14 -8 20 -2 26 -12" fill="none" /><path d="M0 0 C 13 0 19 6 25 4" fill="none" />
            <path d="M0 0 C 12 6 16 12 22 16" fill="none" /><path d="M0 0 C 8 10 8 16 12 22" fill="none" />
            <ellipse cx="0" cy="2" rx="9" ry="12" stroke="none" /><circle cx="0" cy="-11" r="6" stroke="none" />
          </g>
        </svg>
      </div>

      <div className="absolute" style={{ top: 0, right: "30%" }}>
        <svg className="lima-spider lima-spider2" width="34" height="100" viewBox="0 0 46 130">
          <line x1="23" y1="0" x2="23" y2="60" stroke="#2c2926" strokeWidth="1.2" />
          <g className="lima-paper" transform="translate(23,80)" fill="#26231f" stroke="#26231f" strokeWidth="2.4" strokeLinecap="round">
            <path d="M0 0 C -13 0 -19 6 -25 4" fill="none" /><path d="M0 0 C -12 6 -16 12 -22 16" fill="none" />
            <path d="M0 0 C -8 10 -8 16 -12 22" fill="none" /><path d="M0 0 C 13 0 19 6 25 4" fill="none" />
            <path d="M0 0 C 12 6 16 12 22 16" fill="none" /><path d="M0 0 C 8 10 8 16 12 22" fill="none" />
            <ellipse cx="0" cy="2" rx="8" ry="10" stroke="none" /><circle cx="0" cy="-9" r="5" stroke="none" />
          </g>
        </svg>
      </div>

      <div className="absolute lima-paper" style={{ top: 22, left: 30, transform: "rotate(-10deg)" }}>
        <svg width="60" height="30" viewBox="0 0 120 60">
          <circle cx="60" cy="8" r="4" fill="#c0392b" />
          <path d="M60 20 C 52 8 44 6 40 16 C 30 6 12 8 4 26 C 20 20 28 26 32 34 C 40 26 52 30 60 40 C 68 30 80 26 88 34 C 92 26 100 20 116 26 C 108 8 90 6 80 16 C 76 6 68 8 60 20 Z" fill="#2b2723" />
        </svg>
      </div>

      <svg className="absolute top-0 right-0 w-24 h-24 text-[#efe7da]/60" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="1.1" style={{ transform: "scaleX(-1)" }}>
        {[16, 32, 48, 64, 80].map(r => <path key={r} d={`M0 0 A ${r} ${r} 0 0 1 ${r} 0`} />)}
        {[8, 30, 52, 74].map(a => <line key={a} x1="0" y1="0" x2={90 * Math.cos(a * Math.PI / 180)} y2={90 * Math.sin(a * Math.PI / 180)} />)}
      </svg>

      <div className="absolute lima-paper" style={{ bottom: 12, left: 22, transform: "rotate(-6deg)" }}>
        <svg width="46" height="44" viewBox="0 0 100 96">
          <circle cx="50" cy="10" r="5" fill="#4a7d1e" /><rect x="46" y="8" width="8" height="16" rx="3" fill="#4a7d1e" />
          <path d="M50 22 C 20 22 8 42 12 62 C 16 84 40 92 50 92 C 60 92 84 84 88 62 C 92 42 80 22 50 22 Z" fill="#e07a2f" />
          <path d="M28 52 l14 -8 v14 Z" fill="#3a2410" /><path d="M72 52 l-14 -8 v14 Z" fill="#3a2410" />
          <path d="M30 68 q20 16 40 0 q-8 6 -20 6 q-12 0 -20 -6 Z" fill="#3a2410" />
        </svg>
      </div>

      <div className="absolute lima-paper" style={{ bottom: 18, right: 40, transform: "rotate(8deg)" }}>
        <svg width="42" height="21" viewBox="0 0 120 60">
          <path d="M60 20 C 52 8 44 6 40 16 C 30 6 12 8 4 26 C 20 20 28 26 32 34 C 40 26 52 30 60 40 C 68 30 80 26 88 34 C 92 26 100 20 116 26 C 108 8 90 6 80 16 C 76 6 68 8 60 20 Z" fill="#2b2723" />
        </svg>
      </div>
    </div>
  );
};

export default SeasonalDecor;
